/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetYoutubesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetYoutubesOkDto } from '../../src/model';
/**
 * YoutubesApi - axios parameter creator
 * @export
 */
export const YoutubesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 대시보드 뷰업유튜브 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        youtubeControllerGetYoutubes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/youtubes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YoutubesApi - functional programming interface
 * @export
 */
export const YoutubesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YoutubesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 대시보드 뷰업유튜브 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async youtubeControllerGetYoutubes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetYoutubesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.youtubeControllerGetYoutubes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YoutubesApi.youtubeControllerGetYoutubes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YoutubesApi - factory interface
 * @export
 */
export const YoutubesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YoutubesApiFp(configuration)
    return {
        /**
         * 
         * @summary 대시보드 뷰업유튜브 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        youtubeControllerGetYoutubes(options?: RawAxiosRequestConfig): AxiosPromise<GetYoutubesOkDto> {
            return localVarFp.youtubeControllerGetYoutubes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * YoutubesApi - object-oriented interface
 * @export
 * @class YoutubesApi
 * @extends {BaseAPI}
 */
export class YoutubesApi extends BaseAPI {
    /**
     * 
     * @summary 대시보드 뷰업유튜브 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YoutubesApi
     */
    public youtubeControllerGetYoutubes(options?: RawAxiosRequestConfig) {
        return YoutubesApiFp(this.configuration).youtubeControllerGetYoutubes(options).then((request) => request(this.axios, this.basePath));
    }
}

